import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './rfq-portal.css'

const RFQPortal = (props) => {
  return (
    <div className="rfq-portal-container1">
      <Helmet>
        <title>RFQ Portal - Panda Demolition &amp; Disposal</title>
        <meta
          property="og:title"
          content="RFQ Portal - Panda Demolition & Disposal"
        />
        <link
          rel="canonical"
          href="https://www.pandademolition.com/rfq-portal"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="rfq-hero">
        <video
          src="https://videos.pexels.com/video-files/35603078/15087798_360_640_30fps.mp4"
          loop="true"
          muted="true"
          poster="https://images.pexels.com/videos/35603078/pictures/preview-0.jpg"
          autoPlay="true"
          playsInline="true"
          className="rfq-hero-video"
        ></video>
        <div className="rfq-hero-overlay"></div>
        <div className="rfq-hero-content">
          <h1 className="hero-title">
            Precision Demolition. Instant RFQ Delivery.
          </h1>
          <p className="hero-subtitle">
            Industrial-scale clearing, disposal, and site preparation. Get your
            project moving with Panda Demolition’s expert team.
          </p>
          <div className="rfq-hero-actions">
            <a href="#rfq-form">
              <div className="btn btn-xl btn-secondary">
                <span>Start Your RFQ Now</span>
              </div>
            </a>
            <a href="/services">
              <div className="btn-outline btn btn-xl">
                <span>View Capabilities</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section className="rfq-features">
        <div className="rfq-portal-rfq-container">
          <h2 className="section-title">What We Need For Your Quote</h2>
          <div className="rfq-features-steps">
            <div className="rfq-feature-item">
              <div className="rfq-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M8 2v4m8-4v4"></path>
                    <rect x="3" y="4" rx="2" width="18" height="18"></rect>
                    <path d="M3 10h18"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Site Details</h3>
              <p className="section-content">
                Location, structure type, and square footage for accurate
                assessment.
              </p>
            </div>
            <div className="rfq-feature-item">
              <div className="rfq-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M8 2v4m8-4v4"></path>
                    <rect x="3" y="4" rx="2" width="18" height="18"></rect>
                    <path d="M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Timelines</h3>
              <p className="section-content">
                Preferred start dates and any critical project milestones.
              </p>
            </div>
            <div className="rfq-feature-item">
              <div className="rfq-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-5.5 4.5l-5 5m0-5l5 5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Permit Status</h3>
              <p className="section-content">
                Current status of municipal permits and environmental
                clearances.
              </p>
            </div>
            <div className="rfq-feature-item">
              <div className="rfq-feature-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                    <circle r="2" cx="17" cy="18"></circle>
                    <circle r="2" cx="7" cy="18"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Haul-Away</h3>
              <p className="section-content">
                Volume estimates for disposal and specialized recycling needs.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="rfq-process">
        <div className="rfq-portal-rfq-container">
          <h2 className="section-title">The Panda Submission Path</h2>
          <div className="rfq-process-steps">
            <div className="rfq-portal-rfq-step">
              <span className="rfq-step-number">01</span>
              <h3 className="section-subtitle">Submit RFQ</h3>
              <p className="section-content">
                Complete our detailed online form in under 5 minutes.
              </p>
            </div>
            <div className="rfq-portal-rfq-step">
              <span className="rfq-step-number">02</span>
              <h3 className="section-subtitle">Site Review</h3>
              <p className="section-content">
                Our engineers review plans or schedule a rapid site visit.
              </p>
            </div>
            <div className="rfq-portal-rfq-step">
              <span className="rfq-step-number">03</span>
              <h3 className="section-subtitle">Quote Delivery</h3>
              <p className="section-content">
                Receive a comprehensive, itemized quote within 24-48 hours.
              </p>
            </div>
            <div className="rfq-portal-rfq-step">
              <span className="rfq-step-number">04</span>
              <h3 className="section-subtitle">Contracting</h3>
              <p className="section-content">
                Finalize timelines and mobilize the Panda heavy fleet.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="rfq-timeline">
        <div className="rfq-timeline-wrapper">
          <div className="rfq-timeline-header">
            <h2 className="section-title">Standard Project Phase Durations</h2>
            <p className="section-content">
              Plan your project around these typical industry milestones.
            </p>
          </div>
          <div className="rfq-timeline-scroll">
            <div className="rfq-timeline-track">
              <div className="rfq-timeline-event">
                <div className="rfq-event-dot"></div>
                <div className="rfq-event-content">
                  <span className="rfq-event-time">Week 1-2</span>
                  <h4 className="section-subtitle">
                    Permitting &amp; Abatement
                  </h4>
                  <p className="section-content">
                    Securing permits and handling hazardous material removal.
                  </p>
                </div>
              </div>
              <div className="rfq-timeline-event">
                <div className="rfq-event-dot"></div>
                <div className="rfq-event-content">
                  <span className="rfq-event-time">Week 3</span>
                  <h4 className="section-subtitle">Utility Disconnection</h4>
                  <p className="section-content">
                    Coordinating with municipal teams for safe power and water
                    cut-off.
                  </p>
                </div>
              </div>
              <div className="rfq-timeline-event">
                <div className="rfq-event-dot"></div>
                <div className="rfq-event-content">
                  <span className="rfq-event-time">Week 4-6</span>
                  <h4 className="section-subtitle">Structural Demolition</h4>
                  <p className="section-content">
                    Heavy machinery phase: mechanical demolition of all
                    structures.
                  </p>
                </div>
              </div>
              <div className="rfq-timeline-event">
                <div className="rfq-event-dot"></div>
                <div className="rfq-event-content">
                  <span className="rfq-event-time">Week 7</span>
                  <h4 className="section-subtitle">Debris Removal</h4>
                  <p className="section-content">
                    High-volume disposal and site clearing for redevelopment.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="rfq-services">
        <div className="rfq-portal-rfq-container">
          <h2 className="section-title">Critical Submission Requirements</h2>
          <div className="rfq-accordion-group">
            <details open="true" className="rfq-accordion-item">
              <summary className="rfq-accordion-trigger">
                <span className="section-subtitle">
                  Site Plans &amp; Blueprints
                </span>
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="rfq-accordion-icon"
                >
                  <path
                    d="m6 9l6 6l6-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </summary>
              <div className="rfq-accordion-content">
                <p className="section-content">
                  Uploading original structural blueprints helps our team
                  identify load-bearing walls and underground utilities,
                  ensuring a safer and more accurate quote.
                </p>
                <div className="rfq-upload-placeholder">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                      <path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2m-5-10v6"></path>
                      <path d="M9.5 13.5L12 11l2.5 2.5"></path>
                    </g>
                  </svg>
                  <span>Drag &amp; Drop PDF or DWG Files</span>
                </div>
              </div>
            </details>
            <details className="rfq-accordion-item">
              <summary className="rfq-accordion-trigger">
                <span className="section-subtitle">
                  Hazardous Material Reports
                </span>
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="rfq-accordion-icon"
                >
                  <path
                    d="m6 9l6 6l6-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </summary>
              <div className="rfq-accordion-content">
                <p className="section-content">
                  Please include any existing asbestos, lead, or PCB surveys. If
                  these are not available, Panda Demolition can arrange for
                  environmental testing as part of the initial phase.
                </p>
              </div>
            </details>
            <details className="rfq-accordion-item">
              <summary className="rfq-accordion-trigger">
                <span className="section-subtitle">
                  Access &amp; Logistical Constraints
                </span>
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="rfq-accordion-icon"
                >
                  <path
                    d="m6 9l6 6l6-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </summary>
              <div className="rfq-accordion-content">
                <p className="section-content">
                  Specify narrow entryways, proximity to neighboring structures,
                  or noise-sensitive zones (hospitals, schools) that may impact
                  heavy machinery operation hours.
                </p>
              </div>
            </details>
            <details className="rfq-accordion-item">
              <summary className="rfq-accordion-trigger">
                <span className="section-subtitle">
                  Disposal &amp; Recycling Goals
                </span>
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  className="rfq-accordion-icon"
                >
                  <path
                    d="m6 9l6 6l6-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </summary>
              <div className="rfq-accordion-content">
                <p className="section-content">
                  We prioritize LEED certification requirements. Let us know if
                  your project requires specific recycling percentages for
                  concrete, steel, or wood materials.
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>
      <section className="rfq-stats">
        <div className="rfq-stats-grid">
          <div className="rfq-stat-card">
            <span className="rfq-stat-value">5,000+</span>
            <span className="rfq-stat-label">Projects Completed</span>
          </div>
          <div className="rfq-stat-card">
            <span className="rfq-stat-value">120k</span>
            <span className="rfq-stat-label">Tons Disposed Annually</span>
          </div>
          <div className="rfq-stat-card">
            <span className="rfq-stat-value">24hr</span>
            <span className="rfq-stat-label">Average Response Time</span>
          </div>
          <div className="rfq-stat-card">
            <span className="rfq-stat-value">100%</span>
            <span className="rfq-stat-label">Compliance Guarantee</span>
          </div>
        </div>
      </section>
      <section className="rfq-cases">
        <div className="rfq-cases-header">
          <h2 className="section-title">Proven Industrial Results</h2>
        </div>
        <div className="rfq-cases-carousel">
          <div className="rfq-case-card">
            <img
              alt="Warehouse Demolition"
              src="https://images.pexels.com/photos/15804049/pexels-photo-15804049.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="rfq-case-image"
            />
            <div className="rfq-case-content">
              <h3 className="section-subtitle">Metro Industrial Park</h3>
              <p className="section-content">
                Full clearing of 50,000 sq ft warehouse in 14 days. 92% of
                materials recycled.
              </p>
              <span className="rfq-case-tag">Industrial</span>
            </div>
          </div>
          <div className="rfq-case-card">
            <img
              alt="Urban Site Clearing"
              src="https://images.pexels.com/photos/15822215/pexels-photo-15822215.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="rfq-case-image"
            />
            <div className="rfq-case-content">
              <h3 className="section-subtitle">Downtown Plaza Site</h3>
              <p className="section-content">
                Safe removal of complex concrete foundations adjacent to active
                transit lines.
              </p>
              <span className="rfq-case-tag">Urban</span>
            </div>
          </div>
          <div className="rfq-case-card">
            <img
              alt="Emergency Clearing"
              src="https://images.pexels.com/photos/8155814/pexels-photo-8155814.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="rfq-case-image"
            />
            <div className="rfq-case-content">
              <h3 className="section-subtitle">Bridgeport Recovery</h3>
              <p className="section-content">
                Emergency debris removal and structure stabilization following
                storm damage.
              </p>
              <span className="rfq-case-tag">Emergency</span>
            </div>
          </div>
          <div className="rfq-case-card">
            <img
              alt="Residential Redevelopment"
              src="https://images.pexels.com/photos/31249549/pexels-photo-31249549.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
              className="rfq-case-image"
            />
            <div className="rfq-case-content">
              <h3 className="section-subtitle">Heights Commons</h3>
              <p className="section-content">
                Precision demolition of 12 multi-family units for new
                eco-friendly development.
              </p>
              <span className="rfq-case-tag">Residential</span>
            </div>
          </div>
        </div>
      </section>
      <section id="rfq-form" className="rfq-form-section">
        <div className="rfq-form-container">
          <div className="rfq-form-header">
            <h2 className="section-title">Submit Your RFQ</h2>
            <p className="section-content">
              Fill out the form below and our team will deliver a detailed quote within 24-48 hours.
            </p>
          </div>
          <form
            className="rfq-submission-form"
            id="rfq-submission-form"
          >
            <div className="rfq-form-grid">
              <div className="rfq-form-group">
                <label className="rfq-form-label">Full Name</label>
                <input
                  type="text"
                  name="fullname"
                  required
                  placeholder="John Doe"
                  className="rfq-form-input"
                />
              </div>
              <div className="rfq-form-group">
                <label className="rfq-form-label">Company Name</label>
                <input
                  type="text"
                  name="company"
                  placeholder="Your Company"
                  className="rfq-form-input"
                />
              </div>
              <div className="rfq-form-group">
                <label className="rfq-form-label">Email Address</label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="email@example.com"
                  className="rfq-form-input"
                />
              </div>
              <div className="rfq-form-group">
                <label className="rfq-form-label">Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  required
                  placeholder="(555) 000-0000"
                  className="rfq-form-input"
                />
              </div>
              <div className="rfq-form-group">
                <label className="rfq-form-label">Project Type</label>
                <select name="project_type" required className="rfq-form-input">
                  <option value="">Select Project Type</option>
                  <option value="full-demo">Full Demolition</option>
                  <option value="selective-demo">Selective Demolition</option>
                  <option value="site-clearing">Site Clearing</option>
                  <option value="dumpster-rental">Dumpster Rental (Bulk)</option>
                  <option value="debris-hauling">Debris Hauling</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="rfq-form-group">
                <label className="rfq-form-label">Estimated Start Date</label>
                <input
                  type="date"
                  name="start_date"
                  className="rfq-form-input"
                />
              </div>
              <div className="rfq-form-group rfq-form-full">
                <label className="rfq-form-label">Project Address</label>
                <input
                  type="text"
                  name="address"
                  required
                  placeholder="123 Main St, Broward, FL"
                  className="rfq-form-input"
                />
              </div>
              <div className="rfq-form-group rfq-form-full">
                <label className="rfq-form-label">Project Details</label>
                <textarea
                  name="details"
                  rows="4"
                  placeholder="Describe the scope of work, square footage, materials involved, any special requirements..."
                  className="rfq-form-input rfq-form-textarea"
                ></textarea>
              </div>
              <div className="rfq-form-group rfq-form-full">
                <label className="rfq-form-label">Upload Site Plans (optional)</label>
                <input
                  type="file"
                  name="site_plans"
                  accept=".pdf,.dwg,.jpg,.png"
                  className="rfq-form-input"
                />
              </div>
            </div>
            <button type="submit" className="btn btn-xl btn-secondary rfq-form-submit">
              Submit RFQ for Review
            </button>
            <p id="rfq-portal-status" style={{textAlign: 'center', marginTop: '12px', display: 'none'}}></p>
          </form>
        </div>
      </section>
      <section className="rfq-cta">
        <div className="rfq-cta-split">
          <div className="rfq-cta-visual">
            <img
              alt="Demolition Team"
              src="https://images.pexels.com/photos/10958801/pexels-photo-10958801.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            />
            <div className="rfq-cta-visual-overlay"></div>
          </div>
          <div className="rfq-cta-content">
            <h2 className="section-title">Ready to Clear the Way?</h2>
            <p className="section-content">
              Our team is standing by to provide the heavy-duty support your
              project demands. Submit your RFQ today or speak with an expert for
              urgent needs.
            </p>
            <div className="rfq-cta-buttons">
              <a href="#rfq-form">
                <div className="btn-lg btn btn-secondary">
                  <span>Submit Final RFQ</span>
                </div>
              </a>
              <a href="tel:+19544081674">
                <div className="btn-lg btn-outline btn">
                  <span>Call Support</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="rfq-portal-container2">
        <div className="rfq-portal-container3">
          <Script
            html={`<style>
section {
  padding: var(--spacing-4xl) 0;
  position: relative;
  overflow: hidden;
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="rfq-portal-container4">
        <div className="rfq-portal-container5">
          <Script
            html={`<script defer data-name="rfq-portal-enhancements">
(function(){
  // Subtle hover effect for case study cards
  const caseCards = document.querySelectorAll('.rfq-case-card');
  caseCards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      card.style.borderColor = 'var(--color-secondary)';
    });
    card.addEventListener('mouseleave', () => {
      card.style.borderColor = 'transparent';
    });
  });

  // Smooth scroll for internal links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#') return;
      
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });

  // RFQ form submission via Resend API
  const rfqForm = document.getElementById('rfq-submission-form');
  if (rfqForm) {
    rfqForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = rfqForm.querySelector('.rfq-form-submit');
      const status = document.getElementById('rfq-portal-status');
      btn.textContent = 'Sending...';
      btn.disabled = true;
      if (status) status.style.display = 'none';

      const formData = new FormData(rfqForm);
      try {
        const resp = await fetch('/api/rfq', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(Object.fromEntries(formData)),
        });
        const result = await resp.json();
        if (result.success) {
          if (status) {
            status.textContent = '\\u2713 RFQ submitted successfully! Our team will deliver a detailed quote within 24-48 hours.';
            status.style.color = '#16a34a';
            status.style.display = 'block';
          }
          rfqForm.reset();
        } else {
          throw new Error(result.error);
        }
      } catch (err) {
        if (status) {
          status.textContent = 'Something went wrong. Please call us at (954) 408-1674.';
          status.style.color = '#dc2626';
          status.style.display = 'block';
        }
      }
      btn.textContent = 'Submit RFQ for Review';
      btn.disabled = false;
    });
  }

  // Accordion visual feedback
  const detailsElements = document.querySelectorAll('.rfq-accordion-item');
  detailsElements.forEach(details => {
    details.addEventListener('toggle', () => {
      if (details.open) {
        details.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
        details.style.borderColor = 'var(--color-secondary)';
      } else {
        details.style.boxShadow = 'none';
        details.style.borderColor = 'var(--color-border)';
      }
    });
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default RFQPortal
